//
import axios from 'axios'

/**
 *
 */
const update = async (id, data) => {
    //
    try {
        //
        data.commissions = data.commissions.filter(Boolean)

        //
        const response = await axios.put(
            process.env.VUE_APP_API_ROUTE + '/g_user_seller/' + id,
            data
        )

        //
        return response.data
    } catch (error) {
        //
        return error.response.data
    }
}

//
export default update
